import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import * as sw from './register-service-worker';
import { Provider } from 'react-redux';
import store from './fake-cdux/store/store';
import { createRoot } from 'react-dom/client';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <BrowserRouter basename={baseUrl}>
        <Provider store={store}>
            <App />
        </Provider>
  </BrowserRouter>);

// Disable service worker due to non-updated files after app update
//sw.registerServiceWorker();
sw.unregister();
